import '../util/Custom.css'

export function BotaoTitle(props){
  const { marca, icone, cor, title, funcaoClick, parametro, submit } = props.botao

  const classes = "fa" + (!marca ? "s" : "b") + " fa-" + icone + " fa-2x"
          + (cor ? " text-" + cor : "")
  
 


  function handleClick(){
    if(!submit){
      funcaoClick(parametro)
    }
  }

  return (
    <button 
      type={(submit ? 'submit' : 'button')}
      title={title}
      className="link-button ml-1"
      onClick={handleClick}
    >
      <i className={classes}></i>
    </button>
  )
}